#import "../fragments/chat-settings-fragment.graphql"

mutation UpdateChatWidgetIcon($input: ChatWidgetIconUpdateInput!) {
    chatWidgetIconUpdate(input: $input) {
        ...ChatSettingsFragment
    }
}
